import actions from './actions';
import { all, takeEvery, call, put, select } from 'redux-saga/effects';
import { getDeviceEvents } from '../../../api/deviceEvents/deviceEvents.api';
import { SERVER_ERRORS } from '../../../api/SERVER_ERRORS';
import notifications from '../notification/actions';
import {getDeviceType} from "../deviceVersion/selectors";

function* fetchDeviceEvents(payload) {
    try {
        const isKarieDUO = yield select(getDeviceType);
        const params = {
            ...payload.search,
            isKarieDUO
        }
        const response = yield call(getDeviceEvents, params ? params : {});
        if (response.devicesEvents) {
            yield put(actions.fetchDeviceEventsSuccess(response.devicesEvents))
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_DEVICE_EVENTS_ERROR,
            }))
        }
    } catch (error) {
        yield put(notifications.createNotification({
            code: SERVER_ERRORS.COULD_NOT_FIND_DEVICES_EVENTS,
            mainAction: actions.FETCH_DEVICE_EVENTS_ERROR,
        }))
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.FETCH_DEVICE_EVENTS, fetchDeviceEvents),
    ]);
}
